/* =========================================================
   FX LEGACY - Landingpage Script
   - Event delegation so the theme editor can reload sections
     without firing click handlers twice
   - All lookups are guarded against missing sections
   - Translatable strings come from window.FXL_I18N
   ========================================================= */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var bound = false;

  // Uebersetzungen kommen aus dem Layout (window.FXL_I18N).
  // Die Rueckfallwerte greifen nur, falls das Skript ohne Layout laeuft.
  var I18N = window.FXL_I18N || {};
  var TAPE = I18N.tape || {};
  function tr(key, fallback) { return I18N[key] || fallback; }
  function tape(key, fallback) { return TAPE[key] || fallback; }
  var LOCALE = I18N.locale || (document.documentElement.lang || 'en');

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  /* ---------------- Ticker ---------------- */
  function initTicker() {
    var track = $('#fxlTapeTrack');
    if (!track || track.dataset.fxlDone) return;
    track.dataset.fxlDone = '1';
    var items = [
      ['XAU/USD', tape('focus', 'Main focus')], ['EUR/USD', tape('major', 'Major')],
      ['US30', tape('index', 'Index')], ['GBP/USD', tape('major', 'Major')],
      ['USD/JPY', tape('major', 'Major')], ['Order Blocks', tape('setup', 'Setup')],
      ['Liquidity Grab', tape('setup', 'Setup')], ['London Session', tape('timing', 'Timing')],
      ['New York Session', tape('timing', 'Timing')], [tape('risk', 'Risk management'), tape('basics', 'Basics')]
    ];
    var html = items.map(function (it) {
      return '<span class="tape-item"><span class="dot"></span><b>' + it[0] + '</b><span>' + it[1] + '</span></span>';
    }).join('');
    track.innerHTML = html + html;
  }

  /* ---------------- Navigation ---------------- */
  function navOffset() {
    var v = getComputedStyle(document.documentElement).getPropertyValue('--fx-nav-top');
    var n = parseInt(v, 10);
    return isNaN(n) ? 0 : n;
  }

  function scrollToTarget(el) {
    var nav = $('#fxlNav');
    var navH = nav ? nav.offsetHeight + navOffset() : 0;
    var cur = window.pageYOffset || document.documentElement.scrollTop || 0;
    var top = el.getBoundingClientRect().top + cur - navH - 18;
    if (top < 0) top = 0;
    if (reduce) { window.scrollTo(0, top); return; }
    try { window.scrollTo({ top: top, left: 0, behavior: 'smooth' }); }
    catch (e) { window.scrollTo(0, top); }
  }

  function initScrollSpy() {
    var links = $$('#fxlNavLinks a');
    if (!links.length) return;
    var targets = [];
    links.forEach(function (a) {
      var href = a.getAttribute('href') || '';
      if (href.charAt(0) !== '#' || href === '#') return;
      var sec;
      try { sec = document.querySelector(href); } catch (e) { return; }
      if (sec) targets.push({ link: a, sec: sec });
    });
    if (!targets.length) return;

    function update() {
      var pos = window.scrollY + 130 + navOffset();
      var current = null;
      targets.forEach(function (t) { if (t.sec.offsetTop <= pos) current = t; });
      targets.forEach(function (t) { t.link.classList.toggle('active', t === current); });
    }
    if (!initScrollSpy.bound) {
      initScrollSpy.bound = true;
      var ticking = false;
      window.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () { update(); ticking = false; });
      }, { passive: true });
    }
    initScrollSpy.update = update;
    update();
  }

  function initStickyNav() {
    if (initStickyNav.bound) return;
    initStickyNav.bound = true;
    window.addEventListener('scroll', function () {
      var nav = $('#fxlNav');
      if (nav) nav.classList.toggle('stuck', window.scrollY > 20);
    }, { passive: true });
  }

  /* ---------------- Reveal + Zaehler ---------------- */
  function countUp(el) {
    if (el.dataset.fxlCounted) return;
    el.dataset.fxlCounted = '1';
    var target = parseFloat(el.dataset.count);
    var suffix = el.dataset.suffix || '';
    var raw = el.dataset.raw === '1';
    var fmtK = el.dataset.format === 'k';

    function render(v) {
      if (raw) return String(Math.round(v));
      if (fmtK) return Math.round(v / 1000) + 'k+';
      return Math.round(v).toLocaleString(LOCALE) + suffix;
    }
    if (reduce) { el.textContent = render(target); return; }
    var dur = 1400, start = null;
    function step(ts) {
      if (start === null) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      el.textContent = render(target * (1 - Math.pow(1 - p, 3)));
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  function animateRing() {
    var arc = $('#fxlRingArc');
    if (!arc || arc.dataset.fxlDone) return;
    arc.dataset.fxlDone = '1';
    arc.style.transition = reduce ? 'none' : 'stroke-dashoffset 1.6s cubic-bezier(.2,.8,.3,1)';
    requestAnimationFrame(function () { arc.style.strokeDashoffset = 515 * 0.2; });
  }

  function initReveal() {
    var nodes = $$('.fxl .rv').filter(function (el) { return !el.dataset.fxlRv; });
    if (!nodes.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('in');
        if (e.target.classList.contains('psy-ring')) animateRing();
        $$('[data-count]', e.target).forEach(countUp);
        io.unobserve(e.target);
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });

    nodes.forEach(function (el, i) {
      el.dataset.fxlRv = '1';
      el.style.transitionDelay = (Math.min(i, 3) * 60) + 'ms';
      io.observe(el);
    });
  }

  /* ---------------- Hero-Chart ---------------- */
  function buildChart() {
    var svg = $('#fxlChart');
    if (!svg || svg.dataset.fxlDone) return;
    svg.dataset.fxlDone = '1';

    var NS = 'http://www.w3.org/2000/svg';
    var W = 640, H = 400, padL = 14, padR = 74, padT = 22, padB = 30;
    var seed = 20150713;
    function rnd() { seed = (seed * 1103515245 + 12345) & 0x7fffffff; return seed / 0x7fffffff; }

    var closes = [], p = 2318, i;
    for (i = 0; i < 9; i++) { p += 2.2 + rnd() * 3.4; closes.push(p); }
    for (i = 0; i < 10; i++) { p += (rnd() - 0.5) * 7.0; p = Math.max(2334, Math.min(2352, p)); closes.push(p); }
    for (i = 0; i < 4; i++) { p -= 3.2 + rnd() * 4.2; closes.push(p); }
    closes.push(p - 7.5);
    p = closes[closes.length - 1];
    for (i = 0; i < 3; i++) { p += 3.0 + rnd() * 3.0; closes.push(p); }
    for (i = 0; i < 15; i++) { p += 2.6 + rnd() * 4.6 - (rnd() < 0.22 ? 4.0 : 0); closes.push(p); }

    var n = closes.length, candles = [], prev = 2316;
    for (i = 0; i < n; i++) {
      var o = prev, c = closes[i];
      var body = Math.abs(c - o);
      var wick = 1.6 + rnd() * 3.2 + body * 0.22;
      candles.push({ o: o, c: c, h: Math.max(o, c) + wick * (0.4 + rnd() * 0.8), l: Math.min(o, c) - wick * (0.4 + rnd() * 0.8) });
      prev = c;
    }
    var sweepIdx = 23;
    candles[sweepIdx].l -= 6.5;

    var all = [];
    candles.forEach(function (k) { all.push(k.h, k.l); });
    var min = Math.min.apply(null, all), max = Math.max.apply(null, all);
    var padPx = (max - min) * 0.09;
    min -= padPx; max += padPx;

    function X(idx) { return padL + (idx + 0.5) * ((W - padL - padR) / n); }
    function Y(v) { return padT + (max - v) / (max - min) * (H - padT - padB); }
    var cw = Math.max(4, (W - padL - padR) / n * 0.56);

    function mk(tag, attrs) {
      var el = document.createElementNS(NS, tag);
      for (var k in attrs) el.setAttribute(k, attrs[k]);
      return el;
    }

    var gGrid = $('#fxlChartGrid'), gAnno = $('#fxlChartAnno'),
        gC = $('#fxlChartCandles'), gL = $('#fxlChartLabels');
    if (!gGrid || !gAnno || !gC || !gL) return;

    for (i = 0; i <= 4; i++) {
      var v = min + (max - min) * (i / 4), y = Y(v);
      gGrid.appendChild(mk('line', { x1: padL, y1: y, x2: W - padR + 6, y2: y, stroke: 'rgba(232,230,225,.055)', 'stroke-width': 1 }));
      var axisTxt = mk('text', { x: W - padR + 12, y: y + 3.5, fill: '#6b665d', 'font-family': "'JetBrains Mono',monospace", 'font-size': 9, 'letter-spacing': .5 });
      axisTxt.textContent = v.toFixed(1);
      gGrid.appendChild(axisTxt);
    }

    var rangeLow = Math.min(candles[10].l, candles[13].l, candles[16].l);
    var liqY = Y(rangeLow);
    var liqLine = mk('line', { x1: X(9), y1: liqY, x2: X(n - 1), y2: liqY, stroke: '#f3ce63', 'stroke-width': 1, 'stroke-dasharray': '5 5', 'stroke-opacity': .7 });
    liqLine.setAttribute('class', 'anno'); gAnno.appendChild(liqLine);

    var liqTxt = mk('text', { x: X(9), y: liqY - 8, fill: '#f3ce63', 'font-family': "'JetBrains Mono',monospace", 'font-size': 9, 'letter-spacing': 1.4 });
    liqTxt.textContent = tr('liquidity', 'LIQUIDITY'); liqTxt.setAttribute('class', 'anno'); gAnno.appendChild(liqTxt);

    var obTop = Y(Math.max(candles[sweepIdx].o, candles[sweepIdx].c));
    var obBot = Y(Math.min(candles[sweepIdx].o, candles[sweepIdx].c));
    var obBox = mk('rect', {
      x: X(sweepIdx) - cw * 1.1, y: obTop, width: (W - padR) - (X(sweepIdx) - cw * 1.1),
      height: Math.max(10, obBot - obTop), fill: 'url(#fxlObFill)', stroke: 'rgba(201,151,30,.5)',
      'stroke-dasharray': '4 4', 'stroke-width': 1
    });
    obBox.setAttribute('class', 'anno'); gAnno.appendChild(obBox);

    var obTxt = mk('text', { x: X(sweepIdx) + 4, y: obBot + 16, fill: '#c9971e', 'font-family': "'JetBrains Mono',monospace", 'font-size': 9, 'letter-spacing': 1.4 });
    obTxt.textContent = tr('orderblock', 'ORDER BLOCK'); obTxt.setAttribute('class', 'anno'); gAnno.appendChild(obTxt);

    candles.forEach(function (k, idx) {
      var up = k.c >= k.o, col = up ? '#c9971e' : '#6e2a1c';
      var g = mk('g', { 'class': 'cd' });
      g.style.transformOrigin = X(idx) + 'px ' + Y((k.o + k.c) / 2) + 'px';
      g.appendChild(mk('line', { x1: X(idx), y1: Y(k.h), x2: X(idx), y2: Y(k.l), stroke: col, 'stroke-width': 1.2 }));
      g.appendChild(mk('rect', {
        x: X(idx) - cw / 2, y: Y(Math.max(k.o, k.c)), width: cw,
        height: Math.max(1.6, Math.abs(Y(k.o) - Y(k.c))),
        fill: up ? 'url(#fxlBullGrad)' : '#6e2a1c', stroke: col, 'stroke-width': 1
      }));
      gC.appendChild(g);
    });

    var entryY = Y(candles[sweepIdx + 1].o), ex = X(sweepIdx + 1);
    var arrow = mk('path', { d: 'M' + (ex - 16) + ' ' + (entryY + 18) + ' L' + (ex - 2) + ' ' + (entryY + 4), stroke: '#f3ce63', 'stroke-width': 1.4, fill: 'none', 'stroke-linecap': 'round' });
    arrow.setAttribute('class', 'anno'); gL.appendChild(arrow);
    var head = mk('path', { d: 'M' + (ex - 9) + ' ' + (entryY + 5) + ' L' + (ex - 1) + ' ' + (entryY + 3) + ' L' + (ex - 4) + ' ' + (entryY + 11) + ' Z', fill: '#f3ce63' });
    head.setAttribute('class', 'anno'); gL.appendChild(head);
    var eTxt = mk('text', { x: ex - 52, y: entryY + 32, fill: '#f3ce63', 'font-family': "'JetBrains Mono',monospace", 'font-size': 9.5, 'letter-spacing': 1.4, 'font-weight': 600 });
    eTxt.textContent = tr('entry', 'ENTRY'); eTxt.setAttribute('class', 'anno'); gL.appendChild(eTxt);

    var tpY = Y(candles[n - 1].h) - 4;
    var tpLine = mk('line', { x1: X(n - 6), y1: tpY, x2: W - padR, y2: tpY, stroke: '#f3ce63', 'stroke-width': 1, 'stroke-dasharray': '3 4', 'stroke-opacity': .8 });
    tpLine.setAttribute('class', 'anno'); gL.appendChild(tpLine);
    var tpTxt = mk('text', { x: X(n - 6), y: tpY - 7, fill: '#f3ce63', 'font-family': "'JetBrains Mono',monospace", 'font-size': 9.5, 'letter-spacing': 1.4, 'font-weight': 600 });
    tpTxt.textContent = tr('takeprofit', 'TAKE PROFIT'); tpTxt.setAttribute('class', 'anno'); gL.appendChild(tpTxt);

    var sTxt = mk('text', { x: X(sweepIdx) - 24, y: Y(candles[sweepIdx].l) + 18, fill: '#c98a6e', 'font-family': "'JetBrains Mono',monospace", 'font-size': 9, 'letter-spacing': 1.2 });
    sTxt.textContent = tr('sweep', 'SWEEP'); sTxt.setAttribute('class', 'anno'); gL.appendChild(sTxt);

    function play() {
      var nodes = gC.querySelectorAll('.cd');
      var annos = svg.querySelectorAll('.anno');
      if (reduce) {
        Array.prototype.forEach.call(nodes, function (el) { el.classList.add('on'); });
        Array.prototype.forEach.call(annos, function (el) { el.classList.add('on'); });
        return;
      }
      Array.prototype.forEach.call(nodes, function (el, idx) {
        setTimeout(function () { el.classList.add('on'); }, idx * 52);
      });
      setTimeout(function () {
        Array.prototype.forEach.call(annos, function (el, idx) {
          setTimeout(function () { el.classList.add('on'); }, idx * 130);
        });
      }, nodes.length * 52 + 200);
    }

    var played = false;
    function playOnce() {
      if (played) return;
      played = true;
      play();
    }
    try {
      var cio = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { playOnce(); cio.disconnect(); } });
      }, { threshold: 0.25 });
      cio.observe(svg);
    } catch (e) { playOnce(); }
    // Sicherheitsnetz: falls der Beobachter nicht greift, nach 1,2 s trotzdem starten
    setTimeout(playOnce, 1200);
  }

  /* ---------------- Strategie-Akkordeon ---------------- */
  function openStrategy(item) {
    var acc = item.closest('.acc');
    if (!acc) return;
    $$('.acc-item', acc).forEach(function (it) {
      var body = $('.acc-body', it), btn = $('.acc-btn', it);
      var on = (it === item);
      it.classList.toggle('active', on);
      if (btn) btn.setAttribute('aria-expanded', on ? 'true' : 'false');
      if (body) body.style.maxHeight = on ? (body.scrollHeight + 'px') : '0px';
    });
    var idx = parseInt(item.dataset.slide, 10) || 0;
    var stage = $('#fxlSvStage');
    if (stage) {
      $$('.sv-slide', stage).forEach(function (s, i) { s.classList.toggle('on', i === idx); });
    }
    var cap = $('#fxlSvCap');
    if (cap && cap.dataset.caps) {
      var caps = cap.dataset.caps.split('|');
      if (caps[idx]) cap.textContent = caps[idx];
    }
  }

  function initStrategy() {
    var first = $('.fxl .acc .acc-item');
    if (first && !first.closest('.acc').dataset.fxlDone) {
      first.closest('.acc').dataset.fxlDone = '1';
      openStrategy(first);
    }
  }

  /* ---------------- FAQ ---------------- */
  function toggleFaq(item) {
    var list = item.closest('.faq-list');
    if (!list) return;
    var wasOpen = item.classList.contains('active');
    $$('.faq-item', list).forEach(function (o) {
      o.classList.remove('active');
      var a = $('.faq-a', o), b = $('.faq-q', o);
      if (a) a.style.maxHeight = '0px';
      if (b) b.setAttribute('aria-expanded', 'false');
    });
    if (!wasOpen) {
      item.classList.add('active');
      var a = $('.faq-a', item), b = $('.faq-q', item);
      if (a) a.style.maxHeight = a.scrollHeight + 'px';
      if (b) b.setAttribute('aria-expanded', 'true');
    }
  }

  /* ---------------- Globale Klick-Delegation ---------------- */
  function bindGlobal() {
    if (bound) return;
    bound = true;

    document.addEventListener('click', function (ev) {
      var el = ev.target;
      if (!el || !el.closest) return;

      // Burger-Menue
      if (el.closest('#fxlBurger')) {
        var nav = $('#fxlNav');
        if (nav) {
          var open = nav.classList.toggle('open');
          var b = $('#fxlBurger');
          if (b) b.setAttribute('aria-expanded', open ? 'true' : 'false');
        }
        return;
      }

      // Sprungmarken
      var anchor = el.closest('.fxl a[href^="#"]');
      if (anchor) {
        var href = anchor.getAttribute('href');
        if (href && href !== '#') {
          var target = null;
          try { target = document.querySelector(href); } catch (e) { target = null; }
          if (target) {
            ev.preventDefault();
            var nv = $('#fxlNav'), bg = $('#fxlBurger');
            if (nv) nv.classList.remove('open');
            if (bg) bg.setAttribute('aria-expanded', 'false');
            scrollToTarget(target);
            if (window.history && window.history.replaceState) {
              window.history.replaceState(null, '', href);
            }
            return;
          }
        }
      }

      // Strategie-Akkordeon
      var accBtn = el.closest('.fxl .acc-btn');
      if (accBtn) {
        var item = accBtn.closest('.acc-item');
        if (item && !item.classList.contains('active')) openStrategy(item);
        return;
      }

      // FAQ
      var faqBtn = el.closest('.fxl .faq-q');
      if (faqBtn) {
        var fi = faqBtn.closest('.faq-item');
        if (fi) toggleFaq(fi);
        return;
      }

      // Rabattcode kopieren
      var code = el.closest('#fxlCode');
      if (code) {
        var hint = $('#fxlCodeHint');
        var txt = (code.dataset.code || code.textContent || '').trim();
        var reset = hint ? hint.textContent : '';
        function done() {
          if (!hint) return;
          hint.textContent = tr('copied', 'Copied \u00b7 redeem the code at checkout');
          setTimeout(function () { hint.textContent = reset; }, 2600);
        }
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(txt).then(done).catch(done);
        } else { done(); }
      }
    });

    window.addEventListener('resize', function () {
      $$('.fxl .acc-item.active .acc-body').forEach(function (b) { b.style.maxHeight = b.scrollHeight + 'px'; });
      $$('.fxl .faq-item.active .faq-a').forEach(function (a) { a.style.maxHeight = a.scrollHeight + 'px'; });
    });
  }

  /* ---------------- Init ---------------- */
  function init() {
    // Jeder Schritt einzeln, damit ein Fehler nicht die uebrigen blockiert
    [bindGlobal, initTicker, initStickyNav, initScrollSpy, initReveal, buildChart, initStrategy]
      .forEach(function (fn) {
        try { fn(); }
        catch (err) { if (window.console) console.error('[FXL] ' + fn.name + ':', err); }
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme-Editor: Sektionen werden nachgeladen
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:select', init);
})();
